// Übersetzungen: Zahlungslink (/pay/…), Rückfahrt-Vorbelegung und wiederhergestellte Suche. Flache Schlüssel wie in de.js.
const de = {
  auto_returnPrefilled: "Ihre Strecke wurde umgekehrt eingetragen – wählen Sie nur noch Datum und Uhrzeit.",
  auto_returnPrefilledDiscount: "Ihre Strecke wurde umgekehrt eingetragen – wählen Sie nur noch Datum und Uhrzeit. Bei Hin- & Rückfahrt sparen Sie {percent} %.",
  auto_searchRestored: "Wir haben Ihre Suche wiederhergestellt.",
  auto_pay_title: "Online bezahlen",
  auto_pay_booking: "Buchung",
  auto_pay_loading: "Lädt …",
  auto_pay_invalid: "Dieser Link ist ungültig oder abgelaufen.",
  auto_pay_paid: "Vielen Dank – Ihre Zahlung ist eingegangen. Sie müssen dem Fahrer nichts mehr zahlen.",
  auto_pay_verifying: "Zahlung wird geprüft …",
  auto_pay_notPossible: "Für diese Buchung ist keine Online-Zahlung mehr möglich (Fahrt bald, bereits storniert oder abgeschlossen). Bitte zahlen Sie wie gebucht beim Fahrer.",
  auto_pay_total: "Fahrpreis",
  auto_pay_discount: "Online-Zahlung: {percent} % Rabatt",
  auto_pay_toPay: "Zu zahlen",
  auto_pay_button: "Jetzt online zahlen",
  auto_pay_hint: "Sichere Zahlung per Karte über Stripe. Danach müssen Sie dem Fahrer nichts mehr zahlen.",
  auto_pay_cancelled: "Die Zahlung wurde abgebrochen. Sie können es jederzeit erneut versuchen.",
  auto_pay_error: "Die Zahlung konnte nicht gestartet werden. Bitte versuchen Sie es erneut.",
  auto_pay_leg_outbound: "Hinfahrt",
  auto_pay_leg_return: "Rückfahrt",
  auto_pay_leg_oneway: "Fahrt",
};
const en = {
  auto_returnPrefilled: "Your route has been entered in reverse – just choose the date and time.",
  auto_returnPrefilledDiscount: "Your route has been entered in reverse – just choose the date and time. Save {percent}% on a return trip.",
  auto_searchRestored: "We have restored your search.",
  auto_pay_title: "Pay online",
  auto_pay_booking: "Booking",
  auto_pay_loading: "Loading …",
  auto_pay_invalid: "This link is invalid or has expired.",
  auto_pay_paid: "Thank you – your payment has been received. You do not need to pay the driver.",
  auto_pay_verifying: "Checking your payment …",
  auto_pay_notPossible: "Online payment is no longer possible for this booking (trip soon, cancelled or completed). Please pay the driver as booked.",
  auto_pay_total: "Fare",
  auto_pay_discount: "Online payment: {percent}% discount",
  auto_pay_toPay: "To pay",
  auto_pay_button: "Pay now",
  auto_pay_hint: "Secure card payment via Stripe. You then do not need to pay the driver.",
  auto_pay_cancelled: "The payment was cancelled. You can try again at any time.",
  auto_pay_error: "The payment could not be started. Please try again.",
  auto_pay_leg_outbound: "Outbound",
  auto_pay_leg_return: "Return",
  auto_pay_leg_oneway: "Trip",
};
const tr = {
  auto_returnPrefilled: "Güzergâhınız ters olarak girildi – yalnızca tarih ve saati seçin.",
  auto_returnPrefilledDiscount: "Güzergâhınız ters olarak girildi – yalnızca tarih ve saati seçin. Gidiş-dönüşte %{percent} tasarruf edin.",
  auto_searchRestored: "Aramanızı geri yükledik.",
  auto_pay_title: "Online ödeme",
  auto_pay_booking: "Rezervasyon",
  auto_pay_loading: "Yükleniyor …",
  auto_pay_invalid: "Bu bağlantı geçersiz veya süresi dolmuş.",
  auto_pay_paid: "Teşekkürler – ödemeniz alındı. Sürücüye ayrıca ödeme yapmanız gerekmez.",
  auto_pay_verifying: "Ödemeniz kontrol ediliyor …",
  auto_pay_notPossible: "Bu rezervasyon için artık online ödeme yapılamıyor (yolculuk yakın, iptal edilmiş veya tamamlanmış). Lütfen rezervasyonda belirtildiği gibi sürücüye ödeyin.",
  auto_pay_total: "Ücret",
  auto_pay_discount: "Online ödeme: %{percent} indirim",
  auto_pay_toPay: "Ödenecek tutar",
  auto_pay_button: "Şimdi online öde",
  auto_pay_hint: "Stripe üzerinden güvenli kartlı ödeme. Ardından sürücüye ödeme yapmanız gerekmez.",
  auto_pay_cancelled: "Ödeme iptal edildi. İstediğiniz zaman tekrar deneyebilirsiniz.",
  auto_pay_error: "Ödeme başlatılamadı. Lütfen tekrar deneyin.",
  auto_pay_leg_outbound: "Gidiş",
  auto_pay_leg_return: "Dönüş",
  auto_pay_leg_oneway: "Yolculuk",
};
const pl = {
  auto_returnPrefilled: "Trasa została wpisana w odwrotnym kierunku – wybierz tylko datę i godzinę.",
  auto_returnPrefilledDiscount: "Trasa została wpisana w odwrotnym kierunku – wybierz tylko datę i godzinę. Przy podróży w obie strony oszczędzasz {percent}%.",
  auto_searchRestored: "Przywróciliśmy Twoje wyszukiwanie.",
  auto_pay_title: "Zapłać online",
  auto_pay_booking: "Rezerwacja",
  auto_pay_loading: "Ładowanie …",
  auto_pay_invalid: "Ten link jest nieprawidłowy lub wygasł.",
  auto_pay_paid: "Dziękujemy – płatność wpłynęła. Nie musisz już płacić kierowcy.",
  auto_pay_verifying: "Sprawdzamy płatność …",
  auto_pay_notPossible: "Dla tej rezerwacji płatność online nie jest już możliwa (przejazd wkrótce, anulowany lub zakończony). Zapłać kierowcy zgodnie z rezerwacją.",
  auto_pay_total: "Cena przejazdu",
  auto_pay_discount: "Płatność online: rabat {percent}%",
  auto_pay_toPay: "Do zapłaty",
  auto_pay_button: "Zapłać teraz",
  auto_pay_hint: "Bezpieczna płatność kartą przez Stripe. Potem nie musisz płacić kierowcy.",
  auto_pay_cancelled: "Płatność została anulowana. Możesz spróbować ponownie w dowolnym momencie.",
  auto_pay_error: "Nie udało się rozpocząć płatności. Spróbuj ponownie.",
  auto_pay_leg_outbound: "Podróż tam",
  auto_pay_leg_return: "Podróż powrotna",
  auto_pay_leg_oneway: "Przejazd",
};
const uk = {
  auto_returnPrefilled: "Маршрут уже вказано у зворотному напрямку – оберіть лише дату й час.",
  auto_returnPrefilledDiscount: "Маршрут уже вказано у зворотному напрямку – оберіть лише дату й час. Економія {percent}% при поїздці туди й назад.",
  auto_searchRestored: "Ми відновили ваш пошук.",
  auto_pay_title: "Оплатити онлайн",
  auto_pay_booking: "Бронювання",
  auto_pay_loading: "Завантаження …",
  auto_pay_invalid: "Це посилання недійсне або термін його дії минув.",
  auto_pay_paid: "Дякуємо – оплату отримано. Водієві платити не потрібно.",
  auto_pay_verifying: "Перевіряємо оплату …",
  auto_pay_notPossible: "Для цього бронювання онлайн-оплата вже неможлива (поїздка незабаром, скасована або завершена). Сплатіть водієві, як було заброньовано.",
  auto_pay_total: "Вартість поїздки",
  auto_pay_discount: "Онлайн-оплата: знижка {percent}%",
  auto_pay_toPay: "До сплати",
  auto_pay_button: "Сплатити зараз",
  auto_pay_hint: "Безпечна оплата карткою через Stripe. Після цього водієві платити не потрібно.",
  auto_pay_cancelled: "Оплату скасовано. Ви можете спробувати ще раз будь-коли.",
  auto_pay_error: "Не вдалося розпочати оплату. Спробуйте ще раз.",
  auto_pay_leg_outbound: "Туди",
  auto_pay_leg_return: "Назад",
  auto_pay_leg_oneway: "Поїздка",
};
const all = { de, en, tr, pl, uk };
export default all;
